import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CampaignService } from 'src/app/shared/API-Service/services/campaign.service';
import { ApiForImage } from 'src/app/shared/Models/lookup/appSetting';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-list-campaign',
  templateUrl: './list-campaign.component.html',
  styleUrls: ['./list-campaign.component.css']
})
export class ListCampaignComponent extends BaseComponent implements OnInit, OnDestroy {
  private subscription:Subscription= new Subscription()
  public response: any;
  public img: any = ApiForImage
  constructor(
    private _CampaignService: CampaignService,
    private _router: Router,
    private _transition: TranslateService

  ) { super() }

  ngOnInit(): void {
    this.Get();
  }

  public track(index, item) {
    return item.id;
  }

  private Get() {
    this._CampaignService.Get(this.pager).subscribe((res) => {
      this.response = res.data['items'];
      this.totalCount = res.data['totalCount'];
    });
  }
  pageChanged(event: any) {
    this.pageNumber = event.page;// -1 * pageSize;
      this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
    this.Get();

  }
  Delete(id: number) {
    Swal.fire({
      title: this._transition.instant('warning'),
      text: this._transition.instant('Are you sure to delete this file'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F00",
      cancelButtonColor: "#d33",
      confirmButtonText: this._transition.instant('Delete'),
      cancelButtonText: this._transition.instant('Back'),
    }).then((result) => {
      if (result.isConfirmed) {
        this.subscription.add(      this._CampaignService.Delete(id).subscribe(
          (res) => {
            if(res.success===true)
            this.Get();
            Swal.fire({
              icon: "success",
              title: this._transition.instant('It has been deleted successfully'),
              showConfirmButton: false,
              timer: 1500,
            });
          }
        ));
      }
    });
  }

  public Update(id: number) {
    this._router.navigate([`/content/admin/update-Campaign/${id}`]);
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
